'use strict'

import React,{Component} from 'react';

import Area from './Area2.jsx';
import Field from './Field3.jsx';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]);

class Tab extends React.Component {
  select(event) {
    event.preventDefault();
    if (this.props.index<=this.props.available) {
      this.props.onSelect(this.props.index);
    }
  }

  render() {
    var selected=this.props.selected===this.props.index;
    var border="solid grey 5px";
    var color="darkgrey";
    var fontWeight="normal";
    var textDecoration="underline";
    var cursor="pointer";
    if (selected) {
      border="solid #0079BD 5px";
      color="black";
      fontWeight="bold";
      textDecoration="none";
      cursor="normal";
    } else if (this.props.index<this.props.available) {
      border="solid #47b857 5px"; //#4b9d39
      color="black";
      cursor
    } else if (this.props.index>this.props.available) {
      cursor="normal";
      textDecoration="none";
    } else {
      color="black";
      cursor="pointer";
    }
    return (
      <div onClick={this.select.bind(this)} style={{fontSize:"14pt", margin:3, minWidth:100, cursor:cursor, textDecoration: textDecoration, padding: 5, fontWeight:fontWeight, fontFamily:"Lato, Arial", textAlign:"center", borderBottom:border, color:color}}>
       {this.props.title}
     </div>
    );
  }
}

class TabView extends Component {
  constructor(props) {
    super(props);
    this.state=this.calculateState(props, props.selected);
  }

  calculateState(props,selected) {
    var available=0;
    var next=0;
    if (props.item!==undefined && props.item._progress!==undefined) {
      props.areas.forEach((area,index)=>{
        if (area.title===props.item._progress && area.name===undefined || area.name!==undefined && area.name===props.item._progress) {
          available=index;
        }
        if (props.item!==undefined && (area.title===props.item._currentProgress && area.name===undefined || area.name!==undefined && area.name===props.item._currentProgress)) {
          next=index+1 < props.areas.length ? index+1 : props.areas.length-1;
          while (next<props.areas.length-1 && !this.showArea(this.props.areas[next],this.props.displayType)) {
            next=next+1;
          }
        }
      });
    }
    return {
      item: props.updatedItem!==undefined ? props.updatedItem : props.item!==undefined ? props.item : {},
      selected:selected!==undefined ? selected : props.item!==undefined && props.item._currentProgress!==undefined ? next : available,
      available:available
    };
  }

  componentWillReceiveProps(props) {
    this.setState(Object.assign({},this.calculateState(props,props.modified ? this.state.selected : undefined),{
      updated:props.modified===undefined ? true : false
    }));
  }

  select(index) {
    this.setState({
      updated: false,
      selected:index,
      item:Object.assign({},this.state.item,this.getFormValues(this._form))
    });
    if (this.props.onTabChange!==undefined) {
      var selected=this.props.areas[index].name!==undefined ? this.props.areas[index].name : this.props.areas[index].title;
      this.props.onTabChange(selected);
    }
  }

  cancelForm(event) {
    if (event!==undefined) {
      event.preventDefault();
    }
    if (this.props.onCancel!==undefined) {
      this.props.onCancel(event);
    }
  }

  deleteItem(event) {
    if (event!==undefined) {
      event.preventDefault();
    }
    if (this.props.onDelete!==undefined) {
      this.props.onDelete(this.props.item);
    }
  }


  getFormValues(form) {
    var formValues=Object.assign({},this.state.item,{
      id:this.props.item!==undefined ? this.props.item.id : this.state.id!==undefined ? this.state.id : undefined,
    });
    if (form!==undefined && form!==null) {
      for (var i=0; i<form.elements.length; i++) {
        var value=form.elements[i].value;
        if (value.trim().length===0) {
          value=undefined;
        }
        if (form.elements[i].name!==undefined && form.elements[i].name.trim().length>0) {
          formValues[form.elements[i].name]=value;
        }
      }
    }
    formValues.cancel=undefined;
    formValues.save=undefined;
    return formValues;
  }

  submit(event) {
    event.preventDefault();
    if (this.state.available<this.props.areas.length) {
      var formValues=this.getFormValues(event.target); //this._form);
//      var available=this.state.selected>=this.state.available && (this.state.available+1)<this.props.areas.length ? this.state.available+1 : this.state.available;
      var currentArea=this.props.areas[this.state.selected];
      formValues._progress=currentArea.name!==undefined ? currentArea.name : currentArea.title;
      if (this.props.onUpdate!==undefined) {
        if (window!==undefined && window.scrollTo!==undefined) {
          window.scrollTo(0,0);
        };
        var item=Object.assign({},this.state.item,formValues);
        this.props.onUpdate(item);
      }
    }
  }

  showEntryForm(details) {
    if (this.props.onAddEntry!==undefined) {
      this.props.onAddEntry(details);
    }
  }

  showSummaryDetails(status) {
    this.setState({showSummaryDetails:status.show});
  }

  showArea(area,displayType) {
    let excluded=area.excludedFor!==undefined ? area.excludedFor.filter(type=>type===displayType).length>0 : undefined;
    let included=area.includedFor!==undefined ? area.includedFor.filter(type=>type===displayType).length>0 : undefined;
    let show=excluded===undefined && included===undefined || included===undefined && !excluded || included && excluded===undefined ? true : false;
    return show;
  }

  render() {
    let labels=translations.getTranslation(this.props).form;
    var selectedArea=this.props.areas.filter((area,index)=>index===this.state.selected)[0];
    if (this.state.selected>=this.props.areas.length) {
      selectedArea=this.props.areas.slice(-1)[0];
    }
    let saveLabel=this.props.label;
    if (Array.isArray(this.props.label)) {
      let labelForTab=this.props.label.filter(tabLabel=>selectedArea!==undefined && tabLabel.name===selectedArea.name)[0];
      saveLabel= labelForTab!==undefined ? labelForTab.label : undefined;
    }
    return (
      <div>
          {this.state.updated ? (
            <div style={{backgroundColor:"#E4F1E7", fontFamily: "Lato", border:"solid #E4F1E7 1px", marginBottom:10, padding:5, textAlign:"center"}}>
              <b>{labels.changesAreSaved}</b>
            </div>
          ) : null}
          <div style={{display:"flex", justifyContent:"space-around", flexWrap:"wrap"}}>
            {this.state.showSummaryDetails===undefined || this.state.showSummaryDetails===false
              ? this.props.areas.map((area,index) =>
                this.showArea(area,this.props.displayType)!==true ? null :
                (
                  <Tab key={index} index={index} title={area.title!==undefined ? area.title : ".("+area.name+")"} selected={this.state.selected} available={this.state.available} onSelect={this.select.bind(this)}/>
                ))
              : null}
          </div>
        <div style={{paddingTop:15}}>
          {this.props.summary!==undefined
            ? this.props.summary(
              selectedArea!==undefined
                ? selectedArea.name!==undefined
                  ? selectedArea.name
                  : selectedArea.title
                : "(unknown)",
                {
                  values: this.state.item,
                  oldValues: this.props.item!==undefined ? this.props.item : {},
                  onDetails: this.showSummaryDetails.bind(this)
                }
              )
            : null
          }
        </div>
        <form ref={form=>this._form=form} onSubmit={this.submit.bind(this)}>
          <div style={{paddingTop:15}}>
            {this.props.areas.map((area,index) =>
              this.showArea(area,this.props.displayType)!==true ? null :
              index===this.state.selected ? (
              <div key={index}>
                <Area key={area.title} {...area} title={undefined}>
                  {area.fields!==undefined ? area.fields.map(field=>
                    <Field
                      key={field.name!==undefined ? field.name : field.title}
                      language={this.props.language}
                      variant={this.props.variant}
                      {...field}
                      value={this.state.item[field.name]}
                      statusValue={field.includeStatus ? this.state.item[field.name+"_status"] : undefined}
                      previousValue={this.state.item.previousValues!==undefined ? this.state.item.previousValues[field.name] : undefined}
                      previousStatusValue={field.includeStatus && this.state.item.previousValues!==undefined ? this.state.item.previousValues[field.name+"_status"] : undefined}
                      onChange={this.props.handleFieldChange!==undefined ? this.props.handleFieldChange(field.name) : field.onChange}
                      addEntry={field.options!==undefined && field.options.addEntry!==undefined ? Object.assign({},field.options.addEntry,{handler:this.showEntryForm.bind(this)}): null}
                      onEditEntry={this.props.onEditEntry}
                      displayType={this.props.displayType}
                      forceReadOnly={this.props.forceReadOnly}
                      />) : null}
                </Area>
                {saveLabel!==undefined && area.hideButtons!==true ? (
                  <div style={{display:"flex", width:"100%", justifyContent: "space-between"}}>
                    <input className="cancel" type="button" onClick={this.cancelForm.bind(this)} name="cancel" value={labels.cancel}/>
                    {this.props.onDelete!==undefined && (this.props.item!==undefined && this.props.item.id!==undefined)? (
                      <DeleteItem {...this.props} onConfirm={this.deleteItem.bind(this)}/>
                    ) : null}
                    <input className="save" type="submit" name="save" value={this.props.item!==undefined && this.props.item.id===undefined || this.props.item===undefined ? labels.add+" "+saveLabel.toLowerCase() : labels.update+" "+saveLabel.toLowerCase()}/>
                  </div>
                ) : this.props.actions!==undefined ? (
                  this.props.actions
                ) : null }
              </div>
            ) : null )}
          </div>
        </form>
        <div>
          {this.props.details!==undefined ? this.props.details(selectedArea.name!==undefined ? selectedArea.name : selectedArea.title,this.state.item,this.props.item!==undefined ? this.props.item : {}) : null}
        </div>
      </div>
    );
  }
}

class AreaDetails extends Component {
  render() {
    let area=this.props;
    let excluded=this.props.excludedFor!==undefined ? this.props.excludedFor.filter(type=>type===this.props.displayType).length>0 : undefined;
    let included=this.props.includedFor!==undefined ? this.props.includedFor.filter(type=>type===this.props.displayType).length>0 : undefined;
    let show=excluded===undefined && included===undefined || included===undefined && !excluded || included && excluded===undefined ? true : false;
    return false ? (
      <Area title={area.title!==undefined ? area.title : ".("+area.name+")"} {...area}>
        {area.fields.map((field,index)=>
          <Field key={index} {...this.props}  {...field}
            value={field.value!==undefined
              ? field.value
              : this.props.item!==undefined && this.props.item[field.name] !==undefined ? this.props.item[field.name] : undefined}
          />
        )}
      </Area>
    ) : null;
  }
}

export default class AreaForm extends Component {
  cancelForm(event) {
    if (event!==undefined) {
      event.preventDefault();
    }
    if (this.props.onCancel!==undefined) {
      this.props.onCancel(event);
    }
  }

  deleteItem(event) {
    if (event!==undefined) {
      event.preventDefault();
    }
    if (this.props.onDelete!==undefined) {
      this.props.onDelete(this.props.item);
    }
  }

  render() {
    let labels=translations.getTranslation(this.props).form;
    return this.props.display==="tab" ? (
      <TabView {...this.props}/>
    ) : (
      <div>
        {this.props.areas.map((area,index) => (
          <AreaDetails key={index} {...area} {...this.props}/>
        ))}
        {this.props.label!==undefined && !Array.isArray(this.props.label) ? (
          <div>
            <input className="cancel" type="button" onClick={this.cancelForm.bind(this)} name="cancel" value={labels.cancel}/>
            {this.props.onDelete!==undefined && (this.props.item!==undefined && this.props.item.id!==undefined)? (
              <DeleteItem onConfirm={this.deleteItem.bind(this)} label={this.props.label}/>
            ) : null}
            <input className="save" type="submit" name="save" value={this.props.item!==undefined && this.props.item.id===undefined || this.props.item===undefined ? labels.add+" "+this.props.label.toLowerCase() : labels.update+" "+this.props.label.toLowerCase()}/>
          </div>
        ) : this.props.actions!==undefined ? (
          this.props.actions
        ) : null }

      </div>
    );
  }
}


export class DeleteItem extends React.Component {
  constructor(props) {
    super(props);
    this.state={confirm:false};
  }

  deleteItem(event) {
    this.setState({confirm:true});
  }

  confirmDelete(event) {
    this.props.onConfirm(event);
  }

  cancel(event) {
    event.preventDefault();
    this.setState({confirm:false});
  }

  render() {
    let labels=translations.getTranslation(this.props).form;
    return this.state.confirm ? (
      <div style={{border: "solid 1px black", textAlign:"center", padding:5}}>
        <div style={{padding:10}}>
          {this.props.confirmDeleteMessage!==undefined ? this.props.confirmDeleteMessage : labels.confirmDeleteMessage}
        </div>
        <div style={{display: "flex", justifyContent:"space-between"}}>
          <a style={{padding:5, paddingRight: 15}} className="cancel" href="#" onClick={this.cancel.bind(this)}>{labels.cancelDelete}</a>
          <input style={{padding:5}} className="delete" type="button" name="delete" onClick={this.confirmDelete.bind(this)} value={labels.delete+" "+this.props.label.toLowerCase()}/>
        </div>
      </div>
    ) : (
      <input className="delete" type="button" name="delete" onClick={this.deleteItem.bind(this)} value={labels.delete+" "+this.props.label.toLowerCase()}/>
    );
  }
}



// WEBPACK FOOTER //
// ./views/components/AreaForm.jsx